module.exports = __webpack_public_path__ + "img/ion.a246c4df.svg";